/* @flow */
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { when, observable, computed } from 'mobx';
import { NavLink, withRouter } from 'react-router-dom';

import NavigationButton from 'components/NavigationButton/NavigationButton';
import NotificationStore, { Subscription } from 'stores/NotificationStore';
import UserStore from 'stores/UserStore';
import { Roles } from 'permissions/defs';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from './NotificationButton.module.scss';

type InjectedProps = {
  notificationStore: NotificationStore,
  userStore: UserStore,
};

@withRouter
@inject('notificationStore', 'userStore')
@observer
export default class NotificationButton extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  @observable actionableNotificationsSubscription: ?Subscription;

  @computed get count() {
    return (
      (this.actionableNotificationsSubscription &&
        this.actionableNotificationsSubscription.controller.pagination.total) ||
      0
    );
  }

  componentDidMount() {
    const { userStore, notificationStore } = this.props;

    when(
      () => userStore.userLoaded && userStore.userRoleId !== Roles.LOGIN,
      () => {
        this.actionableNotificationsSubscription = notificationStore.subscribeToNotifications(
          { type: 'actionable', urlParams: [], searchParams: [] },
          { background: false }
        );
      }
    );
  }

  componentWillUnmount() {
    const { notificationStore } = this.props;

    if (this.actionableNotificationsSubscription) {
      notificationStore.unsubscribeFromNotifications(this.actionableNotificationsSubscription.id);
    }
  }

  render() {
    return (
      <NavLink
        to={{ pathname: '/notifications', state: { tab: 1 }, search: '?tab=1' }}
        className={styles['notification-button']}
      >
        <NavigationButton>
          <svg>
            <use xlinkHref="#icon-notifications" />
          </svg>
          {this.count > 0 && (
            <span className={styles['notification-button__count']}>
              {this.count.toLocaleString()}
            </span>
          )}
        </NavigationButton>
      </NavLink>
    );
  }
}
